import React, { useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
// import CopyAllIcon from "@material-ui/icons/CopyAll";
import ContentCopySharpIcon from "@material-ui/icons/FileCopyOutlined";
import { ResizableBox } from "react-resizable";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";

import Grid from "@material-ui/core/Grid";
import "./ChomskyAndGreibachAccordion.css";
import { Button } from "@material-ui/core";
import constants from "../../constants/Grammar/responseGrammar";
import { useUser } from "../../context/userContext";
import { useHistory } from "react-router-dom";
import { useGrammar } from "context/grammarContext";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import Draggable from "react-draggable";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 160,
    width: 120,
  },
  control: {
    padding: theme.spacing(2),
  },
  heading: {
    color: "black",
  },
  resizable: {
    position: "relative",
    "& .react-resizable-handle": {
      position: "absolute",
      width: 20,
      height: 20,
      bottom: 0,
      right: 0,
      background:
        "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
      "background-position": "bottom right",
      padding: "0 3px 3px 0",
      "background-repeat": "no-repeat",
      "background-origin": "content-box",
      "box-sizing": "border-box",
      cursor: "se-resize",
    },
  },
}));

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function ChomskyAndGreibachAccordion(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [response, setResponse] = useState("");
  const { language } = useUser();
  const { setOriginalGrammar } = useGrammar();
  const [expandAlgorithm, setExpandAlgorithm] = useState(false);
  const [
    currentTitleChomskyGreibach,
    setCurrentTitleChomskyGreibach,
  ] = useState("");
  const [
    currentVariablesChomskyGreibach,
    setCurrentVariablesChomskyGreibach,
  ] = useState("");
  const [
    currentSolutionChomskyGreibach,
    setCurrentSolutionChomskyGreibach,
  ] = useState("");

  const handleClose = () => {
    setExpandAlgorithm(false);
  };
  const handleChange = (panel) => async (event, isExpanded) => {
    if (!isExpanded) {
      console.log("fechando");
    } else {
      const responseFunction = await props.function();
      console.log(responseFunction);
      setResponse(responseFunction);
    }
    setExpanded(isExpanded ? panel : false);
  };
  //   const { language } = useUser();
  const [spacing] = React.useState(2);
  let history = useHistory();

  const testando = (id) => {
    let el = document.getElementById(id);
    console.log(el);

    if (el.style.display == "flex") {
      el.style.display = "none";
    } else {
      el.style.display = "flex";
    }
  };
  const copyGrammar = (pos) => {
    console.log(document.getElementsByClassName("internal-gram"));

    let cpyGr = document
      .getElementsByClassName("internal-gram")
      [pos].innerText.split("	")
      .join(" ")
      .split("\n\n")
      .join("");

    setOriginalGrammar(cpyGr);
    history.goBack();
  };
  const openDialog = (title, variables, solution) => {
    setCurrentTitleChomskyGreibach(title);
    setCurrentVariablesChomskyGreibach(variables);
    setCurrentSolutionChomskyGreibach(solution);
    setExpandAlgorithm(true);
  };
  return (
    <div>
      <div>
        <Dialog
          open={expandAlgorithm}
          keepMounted
          onClose={handleClose}
          className="dialog"
          scroll="body"
          maxWidth="xl"
          PaperComponent={PaperComponent}
        >
          <ResizableBox
            height={window.innerHeight * 0.75}
            width={window.innerWidth * 0.75}
            className={classes.resizable}
          >
            <div>
              <DialogTitle
                className={classes.dialog}
                id="draggable-dialog-title"
              >
                <div className="wrapper-title">
                  {currentTitleChomskyGreibach}
                  <div className="wrapper-button-close button-margin">
                    <Button
                      style={{ backgroundColor: "#999", color: "#FFF" }}
                      onClick={handleClose}
                    >
                      X
                    </Button>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="wrapper-response">
                  <div className="">{currentVariablesChomskyGreibach}</div>
                  <div className="">{currentSolutionChomskyGreibach}</div>
                </div>
              </DialogContent>
            </div>
          </ResizableBox>
        </Dialog>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          defaultExpanded={false}
          style={{
            backgroundColor: "#e9eaea",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              {constants.accordion.header.chomsky_Greibach}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="chs-gbh-container">
            <div className="container-chomsky-greibach">
              <Grid className="alo3" xl={12}>
                <Grid
                  container
                  justifyContent="center"
                  spacing={spacing}
                  direction="row"
                >
                  <Grid item lg={4} xs={12} className="alo">
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}
                        <div>
                          {constants.accordion.header.nonRecursive[language]}
                        </div>
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i> */}
                        {/* <i className="fa fa-copy interInitial"></i> */}

                        <ContentCopySharpIcon
                          className="icon-copy interInitial"
                          onClick={() => {
                            copyGrammar(0);
                          }}
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.nonRecursive[language],
                              response.varChomSkyNRIS,
                              response.lSolutionCompleteChsNRIS
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomSkyNRIS}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("initial-non-recursive");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="initial-non-recursive">
                        {response.lSolutionCompleteChsNRIS}
                      </div>
                    </div>
                  </Grid>

                  <Grid item lg={4} xs={12}>
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}
                        {constants.accordion.header.nonContractive[language]}
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i>
                    <i className="fa fa-copy interInitial"></i> */}
                        <ContentCopySharpIcon
                          className="icon-copy interInitial"
                          onClick={() => {
                            copyGrammar(1);
                          }}
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.nonContractive[
                                language
                              ],
                              response.varChomSkyENC,
                              response.lSolutionCompleteChsENC
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomSkyENC}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("non-contracting");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="non-contracting">
                        {response.lSolutionCompleteChsENC}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}

                        {constants.accordion.header.noChainRules[language]}
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i>
                    <i className="fa fa-copy interInitial"></i> */}
                        <ContentCopySharpIcon
                          className="icon-copy interInitial"
                          onClick={() => {
                            copyGrammar(2);
                          }}
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.noChainRules[language],
                              response.varChomSkyNC,
                              response.lSolutionCompleteChsNC
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomSkyNC}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("non-chain-rules");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="non-chain-rules">
                        {response.lSolutionCompleteChsNC}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid>
                <Grid
                  container
                  justifyContent="center"
                  spacing={spacing}
                  direction="row"
                >
                  <Grid item lg={4} xs={12}>
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}

                        {constants.accordion.header.onlyTerminals[language]}
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i>
                    <i className="fa fa-copy interInitial"></i> */}
                        <ContentCopySharpIcon
                          className="icon-copy interInitial"
                          onClick={() => {
                            copyGrammar(3);
                          }}
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.onlyTerminals[
                                language
                              ],
                              response.varChomSkyOT,
                              response.lSolutionCompleteChsOT
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomSkyOT}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("only-terminals");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="only-terminals">
                        {response.lSolutionCompleteChsOT}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}

                        {constants.accordion.header.onlyReachable[language]}
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i>
                    <i className="fa fa-copy interInitial"></i> */}
                        <ContentCopySharpIcon
                          className="icon-copy interInitial"
                          onClick={() => {
                            copyGrammar(4);
                          }}
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.onlyReachable[
                                language
                              ],
                              response.varChomSkyOR,
                              response.lSolutionCompleteChsOR
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomSkyOR}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("only-reachable");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="only-reachable">
                        {response.lSolutionCompleteChsOR}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}

                        {constants.accordion.header.chomsky}
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i>
                    <i className="fa fa-copy interInitial"></i> */}
                        <ContentCopySharpIcon
                          className="icon-copy interInitial"
                          onClick={() => {
                            copyGrammar(5);
                          }}
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.chomsky,
                              response.varChomSky,
                              response.lSolutionCompleteChomSky
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomSky}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("chomsky");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="chomsky">
                        {response.lSolutionCompleteChomSky}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid>
                <Grid
                  container
                  justifyContent="center"
                  spacing={spacing}
                  direction="row"
                >
                  <Grid item lg={12} xs={12}>
                    <div
                      id="initial-non-recursive-chomsky"
                      className="item i-chomsky"
                    >
                      <div className="accordion_chomsky_internal">
                        {/* {lInitialNonRec[this.state.index]} */}
                        {constants.accordion.header.greibach}
                      </div>
                      <div className="height0">
                        {/* <i className="fa fa-expand"></i>
                    <i className="fa fa-copy interInitial"></i> */}
                        <ContentCopySharpIcon
                          onClick={() => {
                            copyGrammar(6);
                          }}
                          className="icon-copy interInitial"
                        />
                        <AspectRatioIcon
                          className="expand-icon icon-copy"
                          onClick={() => {
                            openDialog(
                              constants.accordion.header.greibach,
                              response.varChomFNG,
                              response.lSolutionCompleteChsFNG
                            );
                          }}
                        />
                      </div>

                      <div className="internal-gram cnfg response-variables">
                        {/* {this.state.varChomSkyNRIS} */}
                        {response.varChomFNG}
                        {/* <div
                        style={
                          response.varChomFNG ? response.varChomFNG.style : {}
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: response.varChomFNG
                              ? response.varChomFNG.response
                              : "",
                          }}
                        />
                      </div> */}
                      </div>

                      <div style={{ backgroundColor: "#e9eaea" }}>
                        <Button
                          onClick={() => {
                            testando("greibach");
                          }}
                        >
                          {constants.accordion.header.passToPass[language]}
                        </Button>
                      </div>
                      <div className="resposta" id="greibach">
                        {response.lSolutionCompleteChsFNG}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
